import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UserModel } from '../models/user/user.model';
import { CustomerModel } from '../models/customer/customer.model';
import { OrderHeaderModel } from '../models/order/orderheader.model';
import * as _ from "lodash";
import { SalesInd } from '../enums/salesind.enum';

@Injectable()
export class StorageService {

    user: UserModel = <UserModel>{};
    order: OrderHeaderModel = <OrderHeaderModel>{};
    customer: CustomerModel = <CustomerModel>{};
    userId: string = "";
    salesrepCode: string = "";
    token: string = "";
    salesInd: string = "";
    numOfAttachments: number = 0;
    itemsInPage: number = 10;
    itemsInMobilePage: number = 5;
    itemsInOrderListPage: number = 2;
    
    constructor(private storage: Storage) {
    }

    setUser(user: UserModel) {
        this.storage.set('user', user).then(() => {
            this.user = user ? user : <UserModel>{};
        });
    }

    async setToken(token: string) {
        this.token = token;
        return await this.storage.set('token', token);
    }
    
    setSalesInd(salesInd: string) {
        const access = this.user?.accessright_list || [];
        const rights = {
            [SalesInd.NORMAL]: access[2]?.visible === "1",
            [SalesInd.CONSIGNMENT]: access[8]?.visible === "1",
            [SalesInd.FOC]: access[3]?.visible === "1"
        };

        let finalValue = salesInd;

        if (rights[salesInd]) {
            if (salesInd !== SalesInd.CONSIGNMENT) {
                this.storage.remove("orderReason");
            }
        } else {
            finalValue = Object.keys(rights).find(key => rights[key]) || '';
        }

        this.storage.set('salesInd', finalValue).then(() => {
            this.salesInd = finalValue;
        });
    }
    async setOrder(order: OrderHeaderModel) {
        this.storage.set('order', order).then(() => {
            this.order = order ? order : <OrderHeaderModel>{};
        });
    }

    setCustomer(customer: CustomerModel) {
        this.storage.set('selectedCustomer', customer).then(() => {
            this.customer = customer ? customer : <CustomerModel>{};
        });
    }
    
    async setFromSession() {
        if (!this.user || _.isEmpty(this.user)) {
            let user = await this.storage.get('user');
            if (user) {
                this.user = user;
            }
        }
        if (this.token == "") {
            let token = await this.storage.get('token');
            if (token) {
                this.token = token;
            }
        }
        if (this.salesInd == "") {
            let salesInd = this.getSalesInd();
            if (salesInd) {
                this.salesInd = salesInd;
            }
        }
        if (!this.order || _.isEmpty(this.order)) {
            let order = await this.storage.get('order');
            if (order) {
                this.order = order;
            }
        }
        if (!this.customer || _.isEmpty(this.customer)) {
            let customer = await this.storage.get('selectedCustomer');
            if (customer) {
                this.customer = customer;
            }
        }
    }
    getContactInfo() {
        if(this.user && !_.isEmpty(this.user) && !_.isEmpty(this.user.contact_info))
            return this.user.contact_info.toString();
        else
            return "© DKSH Holding Ltd.";
    }

    getContactMessage() {
        if(this.user && !_.isEmpty(this.user) && !_.isEmpty(this.user.contact_message))
            return this.user.contact_message.toString();
        else
            return "Sorry we couldn’t process your request. Please click on refresh or try it again later. If the problem still persist, kindly contact our customer service center";
    }

    getUser() {
        return this.user;
    }
    getUserId() {
        if (this.user && !_.isEmpty(this.user))
            return this.user.user_id.toString();
        else
            return "";
    }
    getSettingId() {
        if (this.user && !_.isEmpty(this.user))
            return this.user.setting_id.toString();
        else
            return "";
    }
    getSalesrepCode() {
        if (this.user && !_.isEmpty(this.user))
            return this.user.salesrep_list[0].salesrep_code.toString();
        else
            return "";
    }
    getPrincipalCode() {
        if (this.user && !_.isEmpty(this.user))
            return this.user.principal_code.toString();
        else
            return "";
    }
    getCountryName(){
        if(this.user && !_.isEmpty(this.user))
            return this.user.country_name.toString();
        else
            return "";
    }
    getCurrency(){
        if(this.user && !_.isEmpty(this.user))
            return this.user.currency.toString();
        else
            return "";
    }

    getToken() {
        return this.token.toString();
    }
    getMaxNumberOfOrderAttachments() {
        if (this.user && !_.isEmpty(this.user)) {
            return this.user.max_num_of_order_attachments.toString();
        }
        else
            return "";
    }
    getSalesInd() {
        const access = this.user?.accessright_list || [];
        const rights = {
            [SalesInd.NORMAL]: access[2]?.visible === "1",
            [SalesInd.CONSIGNMENT]: access[8]?.visible === "1",
            [SalesInd.FOC]: access[3]?.visible === "1"
        };

        if (rights[this.salesInd]) return this.salesInd.toString();

        this.salesInd = Object.keys(rights).find(key => rights[key]) || '';
        return this.salesInd.toString();
    }
    getOrder() {
        return this.order;
    }
    getCustomer() {
        return this.customer;
    }
    getItemsInPage() {
        return this.itemsInPage;
    }
    getItemsInMobilePage() {
        return this.itemsInMobilePage;
    }
    getitemsInOrderListPage() {
        return this.itemsInOrderListPage;
    }
    
    getSetupValue(setupCode: string) {
        if (this.user) {
            let setup = this.user.setup_list.find((r) => { return r.setup_code == setupCode });
            if (setup) {
                return setup.setup_value;
            } else {
                return "";
            }
        }
        return "";
    }

    getAccessRightValue(submoduleCode: string) {
        if (this.user) {
            let accessright = this.user.accessright_list.find((ar) => { return ar.submodule_code == submoduleCode });
            if (accessright) {
                return accessright.visible;
            }
            else {
                return "";
            }
        }
        return "";
    }

    getSalesIndFromOrder(order: OrderHeaderModel){
        if(this.user){
            let ordertype = this.user.order_type_list.find((ot) => { return ot.order_type == order.ord_type});
            if(ordertype){
                return ordertype.sales_ind;
            }
            else{
                return "";
            }
        }
    }

    getOrderType(sales_ind: string){
        if(this.user){
            let ordertype = this.user.order_type_list.find((ot) => { return ot.sales_ind == sales_ind});
            if(ordertype){
                return ordertype.order_type;
            }
            else{
                return "";
            }
        }
    }

    getOrderTypeTitle(sales_ind: string){
        if(this.user){
            let ordertype = this.user.order_type_list.find((ot) => { return ot.sales_ind == sales_ind});
            if(ordertype){
                return ordertype.sales_ind_desc;
            }
            else{
                return "";
            }
        }
    }

    getConditionTypeList(){
        return this.user.condition_type_list;
    }

    getConditionTypeTax(){
        return this.user.condition_type_tax;
    }
    getQuoteContactEmailList(){
        return this.user.qoute_contact_email_list;
    }
    getQuoteMOVInfo(){
        return this.user.quote_mov_info;
    }
    checkCustomerRestrictionPolicy(){
        return this.user.cust_restriction_policy;
    }
    async clearAll() {
        this.user = <UserModel>{};
        this.order = <OrderHeaderModel>{};
        this.customer = <CustomerModel>{};
        this.userId = "";
        this.salesrepCode = "";
        this.token = "";
        this.salesInd = "S";
        this.storage.clear();
    }
    async clearOrder() {
        this.storage.remove('order').then(() => {
            this.order = <OrderHeaderModel>{};
        });
    }
    async clearCustomer() {
        this.storage.remove('selectedCustomer').then(() => {
            this.customer = <CustomerModel>{};
        })
    }

    setNumberOfAttachments(numOfAttachments: number) {
        this.storage.set('numOfAttachments', numOfAttachments).then(() => {
            this.numOfAttachments = numOfAttachments ? numOfAttachments : 0;
        });
    }
    getNumberOfAttachments() {
        return this.numOfAttachments;
    }

    getPrintShipRemark(){
        return this.user.print_ship_remark;
    }

    async setSimulatedOrder(order: OrderHeaderModel) {
        await this.storage.set('simulatedOrder', order);
    }

    async getSimulatedOrder() {
        return await this.storage.get('simulatedOrder');
    }

    async clearSimulatedOrder () {
        return await this.storage.remove('simulatedOrder');
    }
}



// WEBPACK FOOTER //
// ./src/services/storage.service.ts